export default __webpack_public_path__ + "static/media/Rectangle 356 (1).c11db628.png";